var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBiggerAmount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bigger-amount",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67470",
    "data-name": "Group 67470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67469",
    "data-name": "Group 67469"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80539",
    "data-name": "Path 80539",
    d: "M20,5V0H2.5A2.5,2.5,0,0,0,0,2.5V20H5V8.525L28.225,31.75l3.525-3.525L8.525,5Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80540",
    "data-name": "Path 80540",
    d: "M338.05,0h-17.5V5h11.475L308.8,28.225l3.525,3.525L335.55,8.525V20h5V2.5A2.5,2.5,0,0,0,338.05,0Z",
    transform: "translate(-260.55)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80541",
    "data-name": "Path 80541",
    d: "M335.55,332.025,312.325,308.8l-3.525,3.525,23.225,23.225H320.55v5h17.5a2.5,2.5,0,0,0,2.5-2.5v-17.5h-5Z",
    transform: "translate(-260.55 -260.55)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80542",
    "data-name": "Path 80542",
    d: "M28.225,308.64,5,331.89V320.415H0v17.5a2.5,2.5,0,0,0,2.5,2.5H20v-5H8.525L31.75,312.19Z",
    transform: "translate(0 -260.415)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80548",
    "data-name": "Path 80548",
    d: "M-2.078-25.319c0-2.774-2.346-3.59-4.467-4.141v-2.856A5.615,5.615,0,0,1-4.015-30.99L-2.4-33.111a7.083,7.083,0,0,0-4.141-1.815v-1.938H-8.482v1.9c-2.733.265-4.385,2.019-4.385,4.1,0,2.754,2.284,3.569,4.385,4.079v3.2a6.024,6.024,0,0,1-3.243-1.734l-1.571,2.2A7.459,7.459,0,0,0-8.482-21v1.836h1.938v-1.856C-3.546-21.321-2.078-23.076-2.078-25.319ZM-9.89-31.112c0-.734.551-1.265,1.591-1.367v2.59C-9.237-30.133-9.89-30.48-9.89-31.112Zm3.162,7.588V-26.38c.979.286,1.693.632,1.693,1.387C-5.035-24.32-5.566-23.688-6.728-23.524Z",
    transform: "translate(47.591 68.614)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiggerAmount);
export default __webpack_public_path__ + "static/media/bigger-amount.26a8d09030a81f7fe1055a7d7fc66144.svg";
export { ForwardRef as ReactComponent };